export default "images/mail.svg";